import { createFileRoute, redirect } from "@tanstack/react-router";
import { legacyBlogTarget } from "@/lib/legacy-blog-paths";
import { withQuery } from "@/lib/redirect-query";

// Articles live at the root, matching the primary site. Preserve legacy URLs.
// /hair-loss-blog/page/<n>/ also lands here (slug "page") and goes to the
// blog index. Keep the query string so ad and UTM tags survive.
export const Route = createFileRoute("/hair-loss-blog/$slug")({
  beforeLoad: ({ params, location }) => {
    throw redirect({ href: withQuery(legacyBlogTarget(params.slug), location.searchStr), statusCode: 301 });
  },
});
